import { render, staticRenderFns } from "./PcPhoneNumberTextFieldReskinned.vue?vue&type=template&id=535e4b9a"
import script from "./PcPhoneNumberTextFieldReskinned.vue?vue&type=script&lang=js"
export * from "./PcPhoneNumberTextFieldReskinned.vue?vue&type=script&lang=js"
import style0 from "./PcPhoneNumberTextFieldReskinned.vue?vue&type=style&index=0&id=535e4b9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
